// Migrated from transition-web/src/libs/DBApiHandler.ts
// Updated to use new structure

import { collection, doc, getDoc, /* getDocs, */ query, setDoc, updateDoc, deleteField } from 'firebase/firestore'
import { CollectionGroups, Collections } from '../../../pure-js/libs/Collections.js'
import {
  /* getCollectionData, */
  mapQueryResponse,
  toBaseObject
  /* toBaseObject */
} from '../../../pure-js/libs/FirebaseStorageClientBaseHelper.js'
import { Questionnaire, QuestionnaireAnswer } from '../../../pure-js/types/Questionnaire.js'
import { CreateSessionRequest, Session } from 'pure-js/types/Session.js'
import { Slot, SlotDataPoint /* UserSlotDataPointWithId */ } from '../../../pure-js/types/Slot.js'
import { Sprint, SprintActivity } from '../../../pure-js/types/Sprint.js'
import { Team } from '../../../pure-js/types/Team.js'
import { PartialUser, User } from '../../../pure-js/types/User.js'
import { CreateTeamRequest, Id } from '../../../pure-js/types/types.js'
import { State } from '../hooks/useAppState.js'
import { db } from './Firebase.js'

export const updateUser = async (user: PartialUser): Promise<unknown> => {
  const docRef = doc(db, `${Collections.USERS}/${user.id}`)

  // Create update object, using deleteField() for undefined values
  const updateData: Record<string, unknown> = {}
  Object.keys(user).forEach((key) => {
    if (key === 'id') return // Skip id field
    if (user[key as keyof PartialUser] === undefined) {
      updateData[key] = deleteField()
    } else {
      updateData[key] = user[key as keyof PartialUser]
    }
  })

  try {
    await setDoc(docRef, updateData, { merge: true })

    return Promise.resolve()
  } catch (error) {
    throw error
  }
}

export const getUser = (_id: Id): Promise<User | undefined> =>
  getDoc(doc(db, `${Collections.USERS}/${_id}`)).then(mapQueryResponse)

export const getTeam = (_id: Id): Promise<Team | undefined> => {
  // TODO: Implement getTeam

  return Promise.resolve(undefined)
}

export const updateTeam = (t: Team): Promise<Team> => {
  // TODO: Implement updateTeam

  return Promise.resolve(t)
}

export const createTeam = (t: CreateTeamRequest, _state: State): Promise<Team> => {
  // TODO: Implement createTeam

  return Promise.resolve(t as Team)
}

export const getSessions = (_teamId: string) => {
  // TODO: Implement getSessions

  return Promise.resolve([] as Session[])
}

export const upsertSession = (s: CreateSessionRequest) => {
  setDoc(
    doc(db, `${Collections.TEAMS}/${s.teamId}/${CollectionGroups.SESSIONS}/${s.id}`),
    { ...toBaseObject(), ...s },
    {
      merge: true
    }
  )

  // TODO: Implement upsertSession

  return Promise.resolve()
}

export function getSessionsForTeamIdQuery(_teamId: string | undefined) {
  return query(collection(db, `${Collections.TEAMS}/${_teamId}/${CollectionGroups.SESSIONS}`))
}

export const getSlotsForSessions = async ({
  sessionIds: _sessionIds = [],
  teamId: _teamId
}: {
  sessionIds?: string[]
  teamId?: string
}): Promise<Slot[]> => {
  // TODO: Implement getSlotsForSessions

  return Promise.resolve([])
}

export const getUserDataPointMapsForSlots = async ({
  slotIds: _slotIds = [],
  teamId: _teamId,
  sessionId: _sessionId
}: {
  slotIds: string[]
  teamId?: string
  sessionId?: string
}): Promise<SlotDataPoint[]> => {
  // TODO: Implement getUserDataPointMapsForSlots

  return Promise.resolve([])
}

export const getUsersForTeam = (_teamId: string): Promise<User[]> => {
  // TODO: Implement getUsersForTeam

  return Promise.resolve([])
}

export const updateQuestionnaire = async (questionare: Questionnaire): Promise<Questionnaire> => {
  return setDoc(getQuesionaireQuery(questionare), questionare).then(() => questionare)
}

export const getQuesionaireQuery = (questionnaire: { id: string }) => {
  return doc(db, Collections.QUESTIONARES, questionnaire.id)
}

export const updateQuestionareAnswer = async (
  questionnaireAnswer: QuestionnaireAnswer,
  questionaireId: string
): Promise<QuestionnaireAnswer> =>
  setDoc(
    getQuestionareAnswerQuery({ questionaireId, questionId: questionnaireAnswer.questionId }),
    questionnaireAnswer
  ).then(() => questionnaireAnswer)

export const getQuestionareAnswerQuery = ({
  questionId,
  questionaireId
}: {
  questionId: string
  questionaireId: string
}) => doc(db, Collections.QUESTIONARES, questionaireId || 'noId', CollectionGroups.QUESTIONS, questionId || 'noId')

export const getSprints = async (): Promise<Sprint[]> => {
  // TODO: Implement getSprints

  return Promise.resolve([])
}

export const getActivities = async (_sprintId: string): Promise<SprintActivity[]> => {
  // TODO: Implement getActivities

  return Promise.resolve([])
}

export const getSprintReports = async (): Promise<unknown[]> => {
  // TODO: Implement getSprintReports

  return Promise.resolve([])
}

export const upsertSprint = async (_sprint: Sprint): Promise<Sprint> => {
  // TODO: Implement upsertSprint

  return Promise.resolve(_sprint)
}

export const upsertActivity = async (activity: SprintActivity, _sprint: Sprint): Promise<SprintActivity> => {
  // TODO: Implement upsertActivity

  return Promise.resolve(activity)
}

export const upsertSprintReport = async (sprintReport: unknown): Promise<unknown> => {
  // TODO: Implement upsertSprintReport

  return Promise.resolve(sprintReport)
}

export const upsertUser = (user: User): Promise<unknown> =>
  setDoc(doc(db, `${Collections.USERS}/${user.id}`), user, { merge: true })

export const updateTeamIdForUser = (team: string | null, user: Partial<User>): Promise<unknown> =>
  updateDoc(doc(db, `${Collections.USERS}/${user.id}`), 'team', team)
